import {
  GETTING_STARTED_CLASS_ID,
  LEGACY_SAMPLE_CLASS_ID,
} from "./gettingStartedClass";

const RESERVED_PRESENT_CLASS_IDS = [
  LEGACY_SAMPLE_CLASS_ID,
  GETTING_STARTED_CLASS_ID,
];

export function resolveReservedPresentClassIdFromPathname(pathname = "", validClassIds = null) {
  const pathWithoutSearch = String(pathname || "").split(/[?#]/)[0];
  const pathSegments = pathWithoutSearch.split("/").filter(Boolean);

  return RESERVED_PRESENT_CLASS_IDS.find((classId) => (
    pathSegments.includes(classId)
    && (!validClassIds || validClassIds.has(classId))
  )) || null;
}

export function extractPresentClassIdFromPathname(pathname = "", validClassIds = null) {
  const reservedClassId = resolveReservedPresentClassIdFromPathname(pathname, validClassIds);
  if (reservedClassId) {
    return reservedClassId;
  }

  const viewAsPresentMatch = String(pathname || "").match(/\/present\/([^/]+)/);
  if (viewAsPresentMatch?.[1] && (!validClassIds || validClassIds.has(viewAsPresentMatch[1]))) {
    return viewAsPresentMatch[1];
  }

  const match = String(pathname || "").match(/id[a-zA-Z0-9]+/);
  if (match?.[0] && (!validClassIds || validClassIds.has(match[0]))) {
    return match[0];
  }

  return null;
}
